export default "/_next/static/images/8c4986ee4828b47d16f5cd694ef065f2.svg";